export default __webpack_public_path__ + "static/media/p11.bf2ef85c.JPG";